<div id='work-area'>
  <div id='date-setting-tools'>
    <h4>Generate Seasons and Dates to be Audited</h4>
    <!-- <div class="slds-clearfix slds-p-vertical--xx-small"></div> -->
    <div id='season-range'>
      <h5>Season Range</h5>
      <div>
        <label>Start
            <kendo-datepicker
              [title]="'Season Start'"
              [(ngModel)]="startDate"
              [max]="startDateMax"
              [min]="startDateMin"
              [rangeValidation]="true"
              (blur)="checkStartDate()"
              ></kendo-datepicker></label>
        <label>End
            <kendo-datepicker
              [title]="'Season End'"
              [(ngModel)]="endDate"
              [max]="endDateMax"
              [min]="endDateMin"
              [rangeValidation]="true"
              (blur)="checkEndDate()"
              ></kendo-datepicker></label>
      </div>
    </div>
    <div id='day-selection-rules'>
      <h5>Day Generation Rules</h5>
      <div>
        <div>1:
          <kendo-dropdownlist id="dayCount1" name="dayCount1" [data]="dateRankOptions" [(ngModel)]="activeDateSelectionRule.DayInterval1" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
          <kendo-dropdownlist id="day1" name="day1" [data]="dayOptions" [(ngModel)]="activeDateSelectionRule.WeekDaySelection1" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
            </div>
        <div>2:
          <kendo-dropdownlist id="dayCount2" name="dayCount2" [data]="dateRankOptions" [(ngModel)]="activeDateSelectionRule.DayInterval2" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
          <kendo-dropdownlist id="day2" name="day2" [data]="dayOptions" [(ngModel)]="activeDateSelectionRule.WeekDaySelection2" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
            </div>
        <div>3:
          <kendo-dropdownlist id="dayCount3" name="dayCount3" [data]="dateRankOptions" [(ngModel)]="activeDateSelectionRule.DayInterval3" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
          <kendo-dropdownlist id="day3" name="day3" [data]="dayOptions" [(ngModel)]="activeDateSelectionRule.WeekDaySelection3" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
            </div>
        <div>4:
          <kendo-dropdownlist id="dayCount4" name="dayCount4" [data]="dateRankOptions" [(ngModel)]="activeDateSelectionRule.DayInterval4" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
          <kendo-dropdownlist id="day4" name="day4" [data]="dayOptions" [(ngModel)]="activeDateSelectionRule.WeekDaySelection4" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
            </div>
        <div>5:
          <kendo-dropdownlist id="dayCount5" name="dayCount5" [data]="dateRankOptions" [(ngModel)]="activeDateSelectionRule.DayInterval5" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
          <kendo-dropdownlist id="day5" name="day5" [data]="dayOptions" [(ngModel)]="activeDateSelectionRule.WeekDaySelection5" valueField="id" textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{dataItem?.desc}}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="">{{dataItem.desc}}</span>
            </ng-template>
          </kendo-dropdownlist>
            </div>
      </div>
    </div>
    <div id='month-selection-rules'>
      <h5>Month Generation Rules</h5>
      <div>
        <div id='months-col1'>
          <ngl-checkbox label="January"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.January"/></ngl-checkbox>
          <ngl-checkbox label="February"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.February"/></ngl-checkbox>
          <ngl-checkbox label="March"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.March"/></ngl-checkbox>
        </div>
        <div id='months-col2'>
          <ngl-checkbox label="April"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.April"/></ngl-checkbox>
          <ngl-checkbox label="May"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.May"/></ngl-checkbox>
          <ngl-checkbox label="June"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.June"/></ngl-checkbox>
        </div>
        <div id='months-col3'>
          <ngl-checkbox label="July"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.July"/></ngl-checkbox>
          <ngl-checkbox label="August"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.August"/></ngl-checkbox>
          <ngl-checkbox label="September"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.September"/></ngl-checkbox>
        </div>
        <div id='months-col4'>
          <ngl-checkbox label="October"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.October"/></ngl-checkbox>
          <ngl-checkbox label="November"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.November"/></ngl-checkbox>
          <ngl-checkbox label="December"><input ngl type="checkbox" [(ngModel)]="activeDateSelectionRule.December"/></ngl-checkbox>
        </div>
      </div>
    </div>
    <div id="apply-panel">
      <h5>Generate Seasons/Dates</h5>
      <button type="button" class="k-button cvt-primary" (click)="GenerateDatesUsingSeasonRangeControls()">Generate dates using Season Range</button>
      <button type="button" class="k-button cvt-secondary" (click)="GenerateDatesUsingOriginalSeason1()">Generate by original Season 1 dates</button>
      <button type="button" class="k-button cvt-secondary" (click)="RestoreOriginalDayMonthRules()">Restore original Day and Month rules</button>

    </div>
  </div>
  <div id='property-list-and-status'>
    <h4>Imported Property Records</h4>
    <div id='property-list'>
      <div id='msg-type-selector'>Select Property Types to Display&emsp;
        <ngl-checkbox label="Valid"><input ngl type="checkbox" (change)="updateFilter()" [(ngModel)]="showAllValid"/></ngl-checkbox>
        <ngl-checkbox label="Errors"><input ngl type="checkbox" (change)="updateFilter()" [(ngModel)]="showAllErrors"/></ngl-checkbox>
        <ngl-checkbox label="Warnings"><input ngl type="checkbox" (change)="updateFilter()" [(ngModel)]="showAllWarnings"/></ngl-checkbox>
        <ngl-checkbox label="Messages"><input ngl type="checkbox" (change)="updateFilter()" [(ngModel)]="showAllMessages"/></ngl-checkbox>

      </div>
      <div id='grid'>

      <kendo-grid
        [height]="440"
        [data]="viewObserver | async"
        [pageSize]="state.take"
        [pageable]="{buttonCount: 5,info:norecords}"
        [skip]="state.skip"
        [sort]="state.sort"
        [sortable]="true"
        [pageable]="true"
        [selectable]="{enabled:true,mode:'single'}"
        [scrollable]="'scrollable'"
        [selectedKeys]="selectedID"
        [kendoGridSelectBy]
        (pageChange)="pageChange($event)"
        (dataStateChange)="dataStateChange($event)"
        (selectionChange)="propertySelection($event)"
        (cellClick)="cellClickHandler($event)"
        (cellClose)="cellCloseHandler($event)"
        >
        <!-- [kendoGridSelectBy]="'CustomerID'" -->

        <kendo-grid-column field='ImportStatus' title='Status/Action' [width]='148'>
          <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem >
            <div class="raui-grid-buttons">
              <span *ngIf="!dataItem.LoadedFromOriginal">
                  <a class="cvt-icon-trash  grid-cmd-icons" (click)="removeRow(dataItem)" title="Delete Property from list"></a>
                  <span *ngIf="hasError(dataItem)" class="cvt-icon-information grid-cmd-icons" title="Error(s)"></span>
                  <span *ngIf="hasWarning(dataItem)" class="cvt-icon-error grid-cmd-icons" title="Warning(s)"></span>
                  <span *ngIf="hasInfo(dataItem)" class="cvt-icon-comment grid-cmd-icons" title="Message(s)"></span>
              </span>
              <span *ngIf="dataItem.LoadedFromOriginal" class="cvt-icon-internalNote grid-cmd-icons" title="In Program prevous audit, will not be rerun"></span>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field='HotelChainCode' title='Hotel Chain Code' [width]='132'></kendo-grid-column>
        <kendo-grid-column field='ParentHotelName' title='Parent Hotel' [width]='240'></kendo-grid-column>
        <kendo-grid-column field='HotelCRSPropertyCode' title='CRS Property Code' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='PropertyName' title='Property Name' [width]='480'></kendo-grid-column>
        <kendo-grid-column field='PropertyAddress' title='Property Address' [width]='720'></kendo-grid-column>
        <kendo-grid-column field='PropertyCity' title='Property City' [width]='240'></kendo-grid-column>
        <kendo-grid-column field='PropertyStateProvince' title='Property State/Province' [width]='240'></kendo-grid-column>
        <kendo-grid-column field='PropertyPostalCode' title='Property PostalCode' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='PropertyCountry' title='Property Country' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='PropertyPhone' title='Property Phone' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='ContactName' title='Contact Name' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='ContactEMail' title='Contact E-Mail' [width]='240'></kendo-grid-column>
        <kendo-grid-column field='RoomType' title='Room Type' [width]='240'></kendo-grid-column>
        <kendo-grid-column field='LRA' title='LRA (Y/N)' [width]='168'></kendo-grid-column>
        <kendo-grid-checkbox-column field='ProcessAmadeus' title='Audit Amadeus' [width]='120'><ng-template kendoGridCellTemplate let-dataItem ><span *ngIf='dataItem.ProcessAmadeus' class='cvt-icon-check grid-status-icons'></span></ng-template></kendo-grid-checkbox-column>
        <kendo-grid-checkbox-column field='ProcessApollo' title='Audit Apollo' [width]='120'><ng-template kendoGridCellTemplate let-dataItem ><span *ngIf='dataItem.ProcessApollo' class='cvt-icon-check grid-status-icons'></span></ng-template></kendo-grid-checkbox-column>
        <kendo-grid-checkbox-column field='ProcessGalileo' title='Audit Galileo' [width]='120'><ng-template kendoGridCellTemplate let-dataItem ><span *ngIf='dataItem.ProcessGalileo' class='cvt-icon-check grid-status-icons'></span></ng-template></kendo-grid-checkbox-column>
        <kendo-grid-checkbox-column field='ProcessSabre' title='Audit Sabre' [width]='120'><ng-template kendoGridCellTemplate let-dataItem ><span *ngIf='dataItem.ProcessSabre' class='cvt-icon-check grid-status-icons'></span></ng-template></kendo-grid-checkbox-column>
        <kendo-grid-checkbox-column field='ProcessWorldspan' title='Audit Worldspan' [width]='120'><ng-template kendoGridCellTemplate let-dataItem ><span *ngIf='dataItem.ProcessWorldspan' class='cvt-icon-check grid-status-icons'></span></ng-template></kendo-grid-checkbox-column>
        <kendo-grid-column field='AmadeusChainCode' title='Amadeus Chain Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='AmadeusPropCode' title='Amadeus Property Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='AmadeusRateAccessCode' title='Amadeus R.A.C.' [width]='144'></kendo-grid-column>
        <kendo-grid-column field='ApolloChainCode' title='Apollo Chain Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='ApolloPropCode' title='Apollo Property Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='ApolloRateAccessCode' title='Apollo R.A.C.' [width]='144'></kendo-grid-column>
        <kendo-grid-column field='GalileoChainCode' title='Galileo Chain Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='GalileoPropCode' title='Galileo Property Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='GalileoRateAccessCode' title='Galileo R.A.C.' [width]='144'></kendo-grid-column>
        <kendo-grid-column field='SabreChainCode' title='Sabre Chain Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='SabrePropCode' title='Sabre Property Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='SabreRateAccessCode' title='Sabre R.A.C.' [width]='144'></kendo-grid-column>
        <kendo-grid-column field='WorldspanChainCode' title='Worldspan Chain Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='WorldspanPropCode' title='Worldspan Property Code' [width]='204'></kendo-grid-column>
        <kendo-grid-column field='WorldspanRateAccessCode' title='Worldspan R.A.C.' [width]='144'></kendo-grid-column>
        <kendo-grid-column field='RateCurrency' title='Currency' [width]='120'></kendo-grid-column>

        <kendo-grid-column  title='Season 1' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season1StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season1EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 1 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season1DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season1DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season1DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season1DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season1DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 1 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season1ExpectedPrice | price:  dataItem.Season1Dynamic : dataItem.Season1Ceiling '></span></ng-template></kendo-grid-column>


        <kendo-grid-column  title='Season 2' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season2StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season2EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 2 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season2DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season2DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season2DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season2DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season2DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 2 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season2ExpectedPrice | price: dataItem.Season2Dynamic : dataItem.Season2Ceiling '></span></ng-template></kendo-grid-column>


        <kendo-grid-column  title='Season 3' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season3StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season3EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 3 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season3DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season3DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season3DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season3DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season3DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 3 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season3ExpectedPrice | price: dataItem.Season3Dynamic : dataItem.Season3Ceiling '></span></ng-template></kendo-grid-column>


        <kendo-grid-column  title='Season 4' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season4StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season4EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 4 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season4DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season4DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season4DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season4DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season4DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 4 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season4ExpectedPrice | price: dataItem.Season4Dynamic : dataItem.Season4Ceiling '></span></ng-template></kendo-grid-column>


        <kendo-grid-column  title='Season 5' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season5StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season5EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 5 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season5DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season5DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season5DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season5DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season5DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 5 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season5ExpectedPrice | price: dataItem.Season5Dynamic : dataItem.Season5Ceiling '></span></ng-template></kendo-grid-column>


        <kendo-grid-column  title='Season 6' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season6StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season6EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 6 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season6DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season6DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season6DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season6DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season6DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 6 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season6ExpectedPrice | price: dataItem.Season6Dynamic : dataItem.Season6Ceiling '></span></ng-template></kendo-grid-column>


        <kendo-grid-column  title='Season 7' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season7StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season7EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 7 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season7DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season7DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season7DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season7DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season7DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 7 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season7ExpectedPrice | price: dataItem.Season7Dynamic : dataItem.Season7Ceiling '></span></ng-template></kendo-grid-column>


        <kendo-grid-column  title='Season 8' [width]='230'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season8StartDate | dateTimeDate '></span> - <span [innerText]='dataItem.Season8EndDate | dateTimeDate '></span></ng-template></kendo-grid-column>

        <kendo-grid-column  title='Season 8 Run Date(s)' [width]='235'><ng-template kendoGridCellTemplate let-dataItem ><div class='fiveDays'><div><div>1) <span [innerText]='dataItem.Season8DateToCheck1 | dateTimeDate '></span> </div><div>2) <span [innerText]='dataItem.Season8DateToCheck2 | dateTimeDate '></span> </div><div>3) <span [innerText]='dataItem.Season8DateToCheck3 | dateTimeDate '></span><br/> </div></div><div><div>4) <span [innerText]='dataItem.Season8DateToCheck4 | dateTimeDate '></span> </div><div>5) <span [innerText]='dataItem.Season8DateToCheck5 | dateTimeDate '></span></div></div></div></ng-template></kendo-grid-column>




        <kendo-grid-column  title='Season 8 Price' [width]='160'><ng-template kendoGridCellTemplate let-dataItem ><span [innerText]='dataItem.Season8ExpectedPrice | price: dataItem.Season8Dynamic : dataItem.Season8Ceiling '></span></ng-template></kendo-grid-column>

        <kendo-grid-column field='BidAmenityBreakfast' title='Breakfast' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='BidAmenityInternet' title='Internet' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='BidAmenityParking' title='Parking' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='BidAmenityAirport' title='Transportation to Airport' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='BidAmenityLocalShuttle' title='Local Office Transportation' [width]='168'></kendo-grid-column>
        <kendo-grid-column field='BidPolicyCancellation' title='Cancellation Policy' [width]='168'></kendo-grid-column>


      </kendo-grid>
      </div>

    </div>
    <div id='status-messages'>
      <h5>Import Status</h5>
      <div id="import-status-type-selector-bar">
        <span class="cvt-icon-information grid-cmd-icons"></span>
        <ngl-checkbox [label]="'Errors ' + errorList.length.toString()" class="selector-bar"><input ngl type="checkbox" [(ngModel)]="showErrors" /></ngl-checkbox>
        <span class="cvt-icon-error grid-cmd-icons"></span>
        <ngl-checkbox [label]="'Warnings ' + warningList.length.toString()"  class="selector-bar"><input ngl type="checkbox" [(ngModel)]="showWarnings" /></ngl-checkbox>
        <span class="cvt-icon-comment grid-cmd-icons"></span>
        <ngl-checkbox [label]="'Messages ' + messageList.length.toString()"  class="selector-bar"><input ngl type="checkbox" [(ngModel)]="showMessages" /></ngl-checkbox>
      </div>
      <div id="import-status-messages">
        <div *ngIf="showErrors" >
          <div *ngFor="let item of errorList">
              <span class="cvt-icon-information grid-cmd-icons"></span><span [innerText]="item.Message"></span>
          </div>
        </div>
        <div *ngIf="showWarnings" >
            <div *ngFor="let item of warningList">
                <span class="cvt-icon-error grid-cmd-icons"></span><span [innerText]="item.Message"></span>
              </div>
        </div>
        <div *ngIf="showMessages" >
          <div *ngFor="let item of messageList">
              <span class="cvt-icon-comment grid-cmd-icons"></span><span [innerText]="item.Message"></span>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
